<app-close [outlet]="'modal'" testId="dialog-course-completed-close" />

@if (courseProgressLoading()) {
    <div class="loading">
        <app-loader />
    </div>
} @else {
    <div class="container">
        @if (isFullyCompleted()) {
            <div class="message">
                <h2>{{ 'course.completed.title' | translate }}</h2>
                <p>{{ 'course.completed.description' | translate }}</p>
            </div>

            <div class="actions">
                @let link = nextCourseLink() ?? ['/', { outlets: { modal: null } }];

                <a [routerLink]="link" appBtn [fluid]="true" [text]="'course.completed.ok' | translate" data-test="dialog-course-completed-ok"></a>

                @if (!pathId()) {
                    <a
                        [routerLink]="allCoursesLink"
                        appBtn
                        [severity]="'secondary'"
                        [fluid]="true"
                        [text]="'course.completed.all-courses' | translate"
                        data-test="dialog-course-completed-all-courses"
                    ></a>
                }

                <a
                    [routerLink]="['/', { outlets: { primary: 'dashboard', modal: null } }]"
                    appBtn
                    [fluid]="true"
                    [text]="'course.completed.dashboard' | translate"
                    data-test="dialog-course-completed-dashboard"
                ></a>
            </div>
        } @else {
            <div class="message">
                <h2>{{ 'course.completed.title' | translate }}</h2>
                <p>{{ 'course.completed.incomplete.description' | translate }}</p>
            </div>

            <div class="actions">
                <a
                    [routerLink]="['/', { outlets: { modal: null } }]"
                    appBtn
                    [fluid]="true"
                    [text]="'course.completed.finish' | translate"
                    data-test="dialog-course-completed-finish"
                ></a>

                @if (nextCourseLink(); as nextCourseLink) {
                    <a
                        [routerLink]="nextCourseLink"
                        appBtn
                        [severity]="'secondary'"
                        [fluid]="true"
                        [text]="'course.completed.next-course' | translate"
                        data-test="dialog-course-completed-next"
                    ></a>
                } @else if (!pathId()) {
                    <a
                        [routerLink]="allCoursesLink"
                        appBtn
                        [severity]="'secondary'"
                        [fluid]="true"
                        [text]="'course.completed.all-courses' | translate"
                        data-test="dialog-course-completed-all-courses"
                    ></a>
                }
                <a
                    [routerLink]="['/', { outlets: { primary: 'dashboard', modal: null } }]"
                    appBtn
                    [fluid]="true"
                    [text]="'course.completed.dashboard' | translate"
                    data-test="dialog-course-completed-dashboard"
                ></a>
            </div>
        }
    </div>
}
